export const updateForAsyncRequest = (draftState) => {
  draftState.fetching = true
  draftState.fetched = false
  draftState.error = null
  draftState.backupData = draftState.backupData || null
}

export const updateForOptimisticSuccess = (reducerOrData = () => {}, backupData) => (draftState) => {
  // backup previous state in case api call returns error
  if (draftState.backupData === null) {
    if (backupData) {
      draftState.backupData = backupData
    } else {
      // if no backupData provided, use current data object as backupData
      draftState.backupData = draftState.data
    }
  }
  if (typeof reducerOrData === 'function') {
    reducerOrData(draftState)
  } else {
    draftState.data = reducerOrData
  }
}

export const updateForOptimisticBackup = (reducerOrData = () => {}) => (draftState) => {
  if (typeof reducerOrData === 'function') {
    reducerOrData(draftState)
  } else {
    draftState.backupData = { ...draftState.backupData, ...reducerOrData }
  }
}

export const updateForAsyncSuccess = (reducerOrData = () => {}) => (draftState) => {
  draftState.fetching = false
  draftState.fetched = true
  draftState.backupData = null // nullify backupData if success

  // if reducerOrData is a function, execute that function on draftState to update the state
  // else reducerOrData is treated as the next state (then we just need to update draftState.data to the next state in this case)
  if (typeof reducerOrData === 'function') {
    reducerOrData(draftState)
  } else {
    draftState.data = reducerOrData
  }
}

export const updateForAsyncFailure = (action, reducer) => (draftState) => {
  draftState.fetching = false
  draftState.error = action.error
  // roll back to backup state
  if (typeof reducer === 'function') {
    reducer(draftState, draftState.backupData)
  } else if (draftState.backupData !== null && draftState.backupData !== undefined) {
    draftState.data = draftState.backupData
  }
  draftState.backupData = null // nullify backupData
}
